<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :title="reported ? '维修检测报告' : '新增维修检测报告'"
      :close-on-click-modal="false"
      top="1vh"
      width="900px"
      class="CheckReport"
      @close="checkReport = $options.data().checkReport; visualInspectionList = []">
    <div id="printContent" v-loading="contentLoading">
      <div class="reportTop">
        <div style="flex: 1;">
          <div>TK Elevator (China)</div>
          <div>蒂升电梯（中国）</div>
        </div>
        <img style="width:104px" src="../../../../public/img/TKE.png">
      </div>
      <div class="reportTitle">电梯部件问题分析报告</div>
      <div class="table">
        <table style="width: 100%;" cellspacing="0">
          <tr>
            <td colspan="4">项目名称：{{checkReport.projectName}}</td>
            <td colspan="2">NCR编号：{{checkReport.customerOrderNo}}</td>
          </tr>
          <tr>
            <td colspan="2">产品名称：{{checkReport.productName}}</td>
            <td colspan="2">产品型号：{{checkReport.productModel}}</td>
            <td colspan="2">产品编号：{{checkReport.barCodeNo}}</td>
          </tr>
          <tr>
            <td colspan="2">
              生产日期：
              <el-date-picker
                  v-if="!isPrint"
                  v-model="checkReport.productDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 125px"
                  placeholder="选择日期"/>
              <span v-else>{{checkReport.productDate}}</span>
            </td>
            <td style="width: 210px" colspan="2">
              退回日期：
              <el-date-picker
                  v-if="!isPrint"
                  v-model="checkReport.backDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 125px"
                  placeholder="选择日期"/>
              <span v-else>{{checkReport.backDate}}</span>
            </td>
            <td colspan="2">产品数量：{{checkReport.quantity}}</td>
          </tr>
          <tr>
            <td colspan="6" class="cellTitle">A.问题描述</td>
          </tr>
          <tr>
            <td colspan="6">{{checkReport.siteDesc}}</td>
          </tr>
          <tr>
            <td colspan="6" class="cellTitle">B.退件检测维修记录:{{checkReport.inspectionResult}}</td>
          </tr>
          <tr v-if="!checkReport.attachments || !checkReport.attachments.length">
            <td>暂无附件</td>
          </tr>
          <tr>
            <td colspan="6">
              <span v-for="(attachments, index) in attachmentList" :key="index">
                <el-image
                    v-for="(item, subIndex) in attachments"
                    :key="subIndex"
                    style="width: 104px; height: 104px"
                    :src="getPhotoPath(item)"
                    fit="contain"
                    :preview-src-list="[getPhotoPath(item)]"/>
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="6" class="cellTitle">
              <div style="display: flex;align-items: center;">
                <span style="margin-right: 5px">C.故障原因分析</span>
                <el-select
                    v-if="!isPrint"
                    v-model="checkReport.analysisName"
                    style="flex: 1"
                    filterable
                    placeholder="请选择部件类型"
                    clearable>
                  <el-option
                      v-for="item in analysisTemplateList"
                      :key="item.pkid"
                      :label="item.itemName"
                      :value="item.itemName"
                      @click.native="getAnalysisContent(item)"/>
                </el-select>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="6">
              <el-input
                  v-if="!isPrint"
                  v-model="checkReport.causeInvestigation"
                  :disabled="disabled"
                  type="textarea"
                  autosize/>
              <span v-else>{{checkReport.causeInvestigation}}</span>
            </td>
          </tr>
          <tr>
            <td colspan="6">其它：</td>
          </tr>
          <tr>
            <td rowspan="2" style="border-bottom: 1px solid #000;">检查部门：</td>
            <td rowspan="2" style="border-bottom: 1px solid #000;">售后服务部</td>
            <td style="width: 80px">检查人员：</td>
            <td>{{checkReport.checker}}</td>
            <td style="width: 80px">
              确认人员：
            </td>
            <td style="width: 100px">
              <el-input
                  v-if="!isPrint"
                  v-model="checkReport.confirmName"
                  placeholder="请填写"/>
              <span v-else>{{checkReport.confirmName}}</span>
            </td>
          </tr>
          <tr>
            <td>日期：</td>
            <td>
              <el-date-picker
                  v-if="!isPrint"
                  v-model="checkReport.checkDate"
                  type="date"
                  style="width: 125px"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"/>
              <span v-else>{{checkReport.updateTime}}</span>
            </td>
            <td>日期：</td>
            <td>
              <el-date-picker
                  v-if="!isPrint"
                  v-model="checkReport.confirmDate"
                  type="date"
                  style="width: 125px"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"/>
              <span v-else>{{checkReport.confirmDate}}</span>
            </td>
          </tr>
        </table>
        <img style="width:104px" src="../../../../public/img/sign.png" class="sign">
      </div>
    </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!isPrint" type="primary" style="margin-left:5px" @click="saveReport">保存</el-button>
      <el-button :disabled="contentLoading" type="success" style="margin-left:5px" @click="print">打印</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import auth from "@/util/loginUtil";
  import dateUtil from "@/util/dateUtil";
  export default {
    name: "RepairRegistrationReportDS",
    data() {
      return {
        dialogVisible: false,
        isPrint: false,
        disabled: false,
        checker: auth.getName(),
        checkDate: dateUtil.format(new Date(), "yyyy-MM-dd"),
        contentLoading: false,
        reported: true,
        attachmentList: [],
        analysisTemplateList: [],
        visualInspectionList: [],
        checkReport: {
          masterId: "",
          billNo: "",
          elevatorNo: "",
          editor: "",
          manufacturer: "",
          analysisName: "",
          demandAfterSaleTime: "",
          receiptTime: "",
          visualInspection: "",
          visualInspectionNote: "",
          checkAbnormal: "",
          abnormalDesc: "",
          causeInvestigation: "",
          responsibleDecision: "",
          creatorName: "",
          customerName: "",
          customerOrderNo: "",
          afterSaleOrderNo: "",
          receiveSn: "",
          receiveMaterialNo: "",
          receiveMaterialName: "",
          quantity: "",
          repairDate: "",
          siteDesc: "",
          powerOnTime: "",
          runTime: "",
          inspectionResult: "",
          radiatorTemperature: "",
          faultCode: "",
          partList: [],
          originPartList: [],
          attachments: [],
          checker: "",
          confirmName: "",
          confirmDate: "",
          backDate: "",
          productDate: "",
        },
      };
    },
    methods: {
      open(row, master, reported, disabled) {
        this.reported = reported;
        this.isPrint = !!disabled;
        this.dialogVisible = true;
        this.getData(row, master);
        this.getAnalysisTemplateList();
      },
      getData(row, master) {
        this.contentLoading = true;
        let url;
        if (master) {
          url = "repairRegistrationReports/record/" + row.id;
        } else {
          url = "repairRegistrationReports/" + row.id;
        }
        this.$http
          .get("basic", url)
          .then(resp => {
            this.checkReport = resp;
            console.log(this.checkReport);
            this.visualInspectionList = this.checkReport.visualInspection ? this.checkReport.visualInspection.split(",") : [];
            if (master) {
              this.checkReport.masterId = row.id;
            }
            if (this.checkReport.checker === "" || this.checkReport.checker === null) {
              this.checkReport.checker = auth.getName();
            }
            if (this.checkReport.confirmName === "" || this.checkReport.confirmName === null) {
              this.checkReport.confirmName = "曹少勇";
            }
            this.attachmentList = [];
            let array = [];
            this.checkReport.attachments.forEach(item => {
              if (array.length === 0) {
                this.attachmentList.push(array);
              }
              array.push(item);
              if (array.length === 2) {
                array = [];
              }
            });
          })
          .finally(() => {
            this.contentLoading = false;
          });
      },
      getAnalysisTemplateList() {
        this.$http.get("basic", "analysisTemplates/getAllList").then((res) => {
          this.analysisTemplateList = res;
        });
      },
      getAnalysisContent(item) {
        this.checkReport.causeInvestigation = item.itemContent;
      },
      print() {
        this.isPrint = true;
        if (this.disabled) {
          document.body.innerHTML = document.getElementById("printContent").parentNode.innerHTML;
          window.print();
          window.location.reload();
          this.isPrint = false;
        } else {
          this.$http.post("basic", "repairRegistrationReports", this.checkReport).then(() => {
            document.body.innerHTML = document.getElementById("printContent").parentNode.innerHTML;
            window.print();
            window.location.reload();
            this.isPrint = false;
          });
        }
      },
      saveReport() {
        this.$http.post("basic", "repairRegistrationReports", this.checkReport).then(() => {
          this.reported = true;
          this.$emit("save-success");
          this.$message.success("保存成功");
        });
      },
      getPhotoPath(row) {
        let imgUrl = "";
        if (row.filePath.includes("common")) {
          imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
        } else {
          imgUrl = "https://emes.stepelectric.com" + row.filePath;
        }
        return imgUrl;
      },
      visualInspectionSelect() {
        this.checkReport.visualInspection = this.visualInspectionList.length > 0 ? this.visualInspectionList.join(",") : "";
      },
    },
  };
</script>

<style lang="scss" scoped>
#printContent {

  .reportTop {
    display: flex;
    font-size: 18px;
  }

  .reportTitle {
    text-align: center;
    font-size: 26px;
    margin-bottom: 15px;
  }

  .table {
    border: 1px solid #000;
    box-sizing: border-box;
    padding: 3px;
    position: relative;

    tr {
      td {
        border: 1px solid #000;
        border-right: none;
        border-bottom: none;
        padding: 7px 5px;
        width: 210px;

        &:last-child {
          border-right: 1px solid #000;
        }

        &.cellTitle {
          font-size: 16px;
          color: #000;
        }
      }

      &:last-child td {
        border-bottom: 1px solid #000;
      }
    }

    .sign {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}




// .CheckReport {
//   width: 100%;
// }

// .table {
//   width: 100%;
// }

// .table .subTitle {
//   width: 12%;
//   font-size: 13px;
//   font-weight: 600;
// }

// .table .record {
//   font-size: 12px;
// }

// .table table {
//   width: 98%;
//   border-collapse: collapse;
// }

// .table tr {
//   width: 100%;
// }

// .table td {
//   border: 1px solid #333;
//   padding: 5px 10px;
// }

// .input .el-textarea__inner {
//   height: 10vh;
//   width: 98%;
// }

// .footTable table {
//   width: 98%;
//   margin-top: 5px;
//   font-size: 12px;
//   border-collapse: collapse;
//   border: 1px solid #333;
// }

// .footTable table td {
//   width: 50%;
//   padding: 5px 10px;
// }

// ::v-deep .el-checkbox__label {
//   font-size: 12px;
// }

// ::v-deep .el-checkbox__inner {
//   width: 12px;
//   height: 12px;
// }

// ::v-deep .el-radio__label {
//   font-size: 12px;
// }

// ::v-deep .el-radio__inner {
//   width: 12px;
//   height: 12px;
// }</style>
